import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';
import { ArtifactFileKind } from './types';

const artifactIconSx = {
  flexShrink: 0,
  height: 16,
  width: 16,
};

export const getArtifactKindIcon = (kind: ArtifactFileKind = ArtifactFileKind.DEFAULT) => {
  return {
    [ArtifactFileKind.DEFAULT]: <InsertDriveFileOutlinedIcon sx={{ ...artifactIconSx, color: 'text.secondary' }} />,
    [ArtifactFileKind.PDF]: <PictureAsPdfOutlinedIcon sx={{ ...artifactIconSx, color: 'error.main' }} />,
    [ArtifactFileKind.DOCUMENT]: <DescriptionOutlinedIcon sx={{ ...artifactIconSx, color: 'primary.main' }} />,
    [ArtifactFileKind.IMAGE]: <ImageOutlinedIcon sx={{ ...artifactIconSx, color: 'success.main' }} />,
    [ArtifactFileKind.SPREADSHEET]: <TableChartOutlinedIcon sx={{ ...artifactIconSx, color: 'success.main' }} />,
    [ArtifactFileKind.TEXT]: <TextSnippetOutlinedIcon sx={{ ...artifactIconSx, color: 'warning.main' }} />,
  }[kind];
};
